import { EventType, type ReturnType } from './ProductHeader.types'

export const EVENT_MAP: Record<ReturnType, EventType> = {
  address: EventType.ADDRESS_CHANGED,
  branch: EventType.BRANCH_CHANGED,
}
